/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner } from './get-slack-card-notification-settings200-response-inner-user-accounts-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissue } from './get-slack-card-notification-settings200-response-inner-user-accounts-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser } from './get-slack-card-notification-settings200-response-inner-user-accounts-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup } from './get-slack-card-notification-settings200-response-inner-user-accounts-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
 */
export interface GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableCurrencies': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner>}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'availableMerchantCategories': Array<GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'user': GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUser;
    /**
     * 
     * @type {GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'userAccountGroup'?: GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissue}
     * @memberof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInner
     */
    'reissue'?: GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerReissue | null;
}

export const GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum = typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum[keyof typeof GetSlackCardNotificationSettings200ResponseInnerUserAccountsInnerAvailableCurrenciesEnum];


